export class CommonUtils {
  private mArr = [
    { Label: 'Jan', Value: '1' },
    { Label: 'Feb', Value: '2' },
    { Label: 'Mar', Value: '3' },
    { Label: 'Apr', Value: '4' },
    { Label: 'May', Value: '5' },
    { Label: 'Jun', Value: '6' },
    { Label: 'Jul', Value: '7' },
    { Label: 'Aug', Value: '8' },
    { Label: 'Sep', Value: '9' },
    { Label: 'Oct', Value: '10' },
    { Label: 'Nov', Value: '11' },
    { Label: 'Dec', Value: '12' }
  ];

  public constructor() {
  }
  arrayToObject(array) {
    array.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  }
  public getRowExpandedStatus = (item, arr) => {
    let parentRow;
    for (let i = 0; i < arr.length; i++) {
      if (item.ParentRow === arr[i].RowNo) {
        parentRow = arr[i];
        break;
      }
    }
    if (parentRow && item.RowNo && item.RowNo.indexOf('.') >= 0) {
      return parentRow.isExpanded;
    }
    return true;
  }

  public getRowHasChild = (item, arr) => {
    const hasChild = false;
    for (let i = 0; i < arr.length; i++) {
      if (item.RowNo === arr[i].ParentRow && item.ParentRow === '0') {
        return true;
      }
    }
    return hasChild;
  }

  public getLastDayOfMonth = (year, month) => {
    let lastDay;
    lastDay = new Date(year, month, 0);
    return lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate();
  }
  public getLastDayOfMonthByDate = (dt) => {
    let lastDay;
    const date = new Date(dt);
    lastDay = new Date(date.getFullYear(), (date.getMonth() + 1), 0);
    return lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate();
  }
  public getFirstDayOfMonth = (year, month) => {
    const firstDay = new Date(year, (month - 1), 1);
    const mm = (firstDay.getMonth() + 1) < 10 ? '0' + (firstDay.getMonth() + 1) : (firstDay.getMonth() + 1);
    const dd = firstDay.getDate() < 10 ? '0' + firstDay.getDate() : firstDay.getDate();
    return firstDay.getFullYear() + '-' + mm + '-' + dd;
  }
  public getFirstDayOfMonthByDate = (dt) => {
    let firstDay;
    const date = new Date(dt);
    const dm = date.getMonth() + 1;
    firstDay = new Date(date.getFullYear() + '/' + dm + '/' + '1');
    const mm = (firstDay.getMonth() + 1) < 10 ? '0' + (firstDay.getMonth() + 1) : (firstDay.getMonth() + 1);
    const dd = firstDay.getDate() < 10 ? '0' + firstDay.getDate() : firstDay.getDate();
    return firstDay.getFullYear() + '-' + mm + '-' + dd;
  }
  public getFutureYearByLimit = (limit) => {
    const yearArr: any = [];
    for (let d = 0; d < limit; d++) {
      const yrArrObj = {
        Value: 0,
        Label: '',
        ShortLabel: ''
      };
      const dt = new Date();
      const currYr = dt.getFullYear();
      yrArrObj.Value = dt.getFullYear() + d;
      yrArrObj.Label = (dt.getFullYear() + d).toString();
      yrArrObj.ShortLabel = (dt.getFullYear() - d).toString().substr(-2);
      yearArr.push(yrArrObj);
    }
    return yearArr;
  }
  public getFinancialMonthList = year => {
    const dd = new Date();
    const cy = dd.getFullYear();
    const ny = dd.getFullYear() + 1;
    const cm = dd.getMonth() + 1;
    const mList = this.mArr;
    // if (year === cy) {
    //   for (let i = 0; i < this.mArr.length; i++) {
    //     if (Number(this.mArr[i].Value) > cm && Number(this.mArr[i].Value) > 3) {
    //       this.mArr.push(this.mArr[i]);
    //     }
    //   }
    // } else if (year === ny) {
    //   for (let i = 0; i < this.mArr.length; i++) {
    //     if (Number(this.mArr[i].Value) < 4) {
    //       this.mArr.push(this.mArr[i]);
    //     }
    //   }
    // }
    return mList;
  }
  public getPreviosYears = count => {
    const yearArr: any = [];
    for (let d = 0; d < count; d++) {
      const yrArrObj = {
        Value: 0,
        Id: '',
        Label: ''
      };
      const dt = new Date();
      yrArrObj.Value = dt.getFullYear() - d;
      yrArrObj.Label = (dt.getFullYear() - d).toString();
      yrArrObj.Id = (dt.getFullYear() - d).toString().substr(-2);
      yearArr.push(yrArrObj);
    }
    return yearArr;
  }

  public getMonthByLimit(tillMonth) {
    const monthArr: any = [];
    for (let m = 0; m < tillMonth; m++) {
      monthArr.push(this.mArr[m]);
    }
    return monthArr;
  }

  public onYearChange(year, limit) {
    const dd = new Date();
    const yy = dd.getFullYear();
    const cm = dd.getMonth();
    const mm = limit;
    let newMonthArr: any = [];
    const result = {
      year: '',
      month: {},
      monthArr: []
    };
    if (yy === year) {
      for (let i = 0; i < mm; i++) {
        newMonthArr.push(this.mArr[i]);
      }
      result.monthArr = newMonthArr;
      result.month = newMonthArr[mm - 1];
      result.year = year;
      return result;
    } else {
      newMonthArr = this.mArr;
      result.monthArr = newMonthArr;
      result.month = newMonthArr[cm];
      result.year = year;
      return result;
    }
  }
  getCharCount(str, letter) {
    let letterCount = 0;
    for (let position = 0; position < str.length; position++) {
      if (str.charAt(position) === letter) {
        letterCount += 1;
      }
    }
    return letterCount;
  }

  static createUUID() {
    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

  static createShortUUID() {
    let firstPart:any = (Math.random() * 46656) | 0;
    let secondPart:any = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
  }

  public static checkFalseValue(val: any): boolean {
    return !(val === null || val === undefined || val === '');
  }

  public static uniqBy(array: any[], iteratee: any): any[] {
    // Create an empty object to store unique values
    const seen = new Set();
    // Create an empty array to store the result
    const result:any[] = [];
  
    // Loop through each item in the array
    for (const item of array) {
      // Determine the key for uniqueness based on the iteratee
      const key = typeof iteratee === 'function' ? iteratee(item) : item[iteratee];
  
      // Check if the key has already been seen
      if (!seen.has(key)) {
        // If not, add the key to the set and the item to the result
        seen.add(key);
        result.push(item);
      }
    }
  
    return result;
  }

  public static toTitleCase(str: string): string {
    return str
      .toLowerCase() // Convert the entire string to lowercase
      .split(' ')     // Split the string by spaces to get words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
      .join(' ');     // Join the words back with spaces
  }
  
}
